import request from '@/utils/request'

export function add(data) {
  return request({
    url: '/website/liveMessage/send',
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: data
  })
}



// WEBPACK FOOTER //
// ./src/api/index.js